import { AppRouter } from "../../routes/AppRouter";
import { useEffect, useState } from "react";
import {
  LangContext,
  UiTextsContext,
  UserDataContext,
  RegisterUserContext,
} from "../../contexts/Contexts";
import {
  interfaceTexts,
  userInfoLL,
  userPhotoLL,
} from "../../../infrastructure/storage/LocalStorageIds";
import { VersionFooter } from "../../components/uiElements/VersoinFooter";
import { langSchemeService } from "../../../infrastructure/services/InterfaceService";
import {
  getLocalItem,
  setLocalItem,
} from "../../../infrastructure/storage/LocalStorage";
import { NotificationsCenterProvider } from "../../contexts/NotificationsCenterProvider";
import { normalizeInterfaceLanguage } from "../../../shared/utils/interfaceLanguage";
import "../../styles/layout.css";
import "../../styles/spaces.css";

// La normalizacion vive en shared/utils/interfaceLanguage: la comparten los
// puntos que no pueden leer LangContext (clearSessionData, la pantalla de sesion
// expirada), y una sola definicion evita que la pantalla y sus avisos discrepen
// sobre en que idioma esta la interfaz.
const getInitialLanguage = () => {
  const storedLanguage = getLocalItem("language");
  if (storedLanguage) return normalizeInterfaceLanguage(storedLanguage);

  const storedUser = getLocalItem(userInfoLL);
  return normalizeInterfaceLanguage(storedUser?.idioma || "en");
};

export const LayoutTemplate = () => {
  const [lang, setLang] = useState(getInitialLanguage);
  const [userData, setUserData] = useState(getLocalItem("userInfo") || {});
  const [texts, setTexts] = useState({});
  const [textsReady, setTextsReady] = useState(false);
  const [register, setRegister] = useState(
    getLocalItem("fechaRegistro") || null
  );

  useEffect(() => {
    initializeUser();
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function getLangScheme(language) {
      const normalizedLanguage = normalizeInterfaceLanguage(language);

      if (language !== normalizedLanguage) {
        setLang(normalizedLanguage);
        return;
      }

      // No ponemos textsReady en false al cambiar idioma: hacerlo desmontaba
      // AppRouter completo y volvía a disparar todos los efectos/endpoints.
      setLocalItem("language", normalizedLanguage);

      try {
        const dataTxt = await langSchemeService(normalizedLanguage);
        if (cancelled) return;
        setTexts(dataTxt?.texts || {});
      } catch (error) {
        console.error("Failed get lang schema", error);
        if (!cancelled) {
          setTexts(getLocalItem(interfaceTexts) || {});
        }
      } finally {
        if (!cancelled) {
          setTextsReady(true);
        }
      }
    }

    getLangScheme(lang);

    return () => {
      cancelled = true;
    };
  }, [lang]);

  useEffect(() => {
    if (register) {
      setLocalItem("fechaRegistro", register);
    }
  }, [register]);

  const initializeUser = () => {
    const userData = getLocalItem(userInfoLL);
    const profPic = getLocalItem(userPhotoLL);
    if (userData && profPic) {
      setUserData({
        ...userData,
        profilePic: profPic,
      });
    }
    return userData;
  };

  return (
    <LangContext.Provider
      value={{
        lang,
        setLang,
      }}
    >
      <UserDataContext.Provider
        value={{
          userData,
          setUserData,
        }}
      >
        <RegisterUserContext.Provider
          value={{
            register,
            setRegister,
          }}
        >
          <UiTextsContext.Provider
            value={{
              texts,
              setTexts,
            }}
          >
            {textsReady && (
              <NotificationsCenterProvider>
                <AppRouter />
                <VersionFooter />
              </NotificationsCenterProvider>
            )}
          </UiTextsContext.Provider>
        </RegisterUserContext.Provider>
      </UserDataContext.Provider>
    </LangContext.Provider>
  );
};
